export const AuthKeys = {
  accessTokenLegacy: "ACCESS_TOKEN_LEGACY",
  refreshTokenLegacy: "REFRESH_TOKEN_LEGACY",
  accessTokenNamek: "ACCESS_TOKEN_NAMEK",
} as const;

export type AuthKeys = (typeof AuthKeys)[keyof typeof AuthKeys];
